/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import ActionList from '@ingka/action-list';
import Topic from 'Components/topic/Topic.jsx';
import { ROUTE_BASE } from 'Constants/routes';
import { setSelectedTopicId } from 'Store/reducer/selectedTopic';

import { useAppDispatch } from 'Store/index';
import { sendAnalyticEvent } from '../../utils/analytics';

const TopicsBlock = ({ homeTopics }) => {
    const dispatch = useAppDispatch();

    const numerOfTopics = [5, 6, 9];
    const isLayoutAdditional = numerOfTopics.includes(homeTopics.length);
    const getClassName = isLayoutAdditional ? 'topics-container-additional' : 'topics-container';

    const sendToAnalytics = (topic) => {
        sendAnalyticEvent({ action: 'First topic', category: `CSP-1-${topic.topicHeadline}` });
    };

    const topicClickHandler = (topic) => {
        // Next page
        dispatch(setSelectedTopicId({ topicId: topic.id }));
        sendToAnalytics(topic);
    };
    return (
        <ActionList className={getClassName} data-cy="topics-list" id="topicsList">
            {homeTopics.map((topic, index) => (
                <li className="list" key={topic.id}>
                    <Link
                        key={topic.id}
                        to={`${ROUTE_BASE}/t/${topic.id}/`}
                        className="topic-link"
                        tabIndex="-1"
                    >
                        <Topic
                            id={`topic-${index}`}
                            label={topic.topicHeadline}
                            caption={topic.topicBody}
                            clickHandler={() => topicClickHandler(topic)}
                        />
                    </Link>
                </li>
            ))}
        </ActionList>
    );
};

export default TopicsBlock;
